module.exports = __webpack_public_path__ + "static/img/bg_my_empty.048ec20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg_my_empty.svg
// module id = lK0S
// module chunks = 10